/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axios from "axios";
import store from "../../store/index";
// import moment from "moment";
// import { ref } from 'vue'
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
     countsMap: {
    type: Object,
    default: () => ({}),
  },
    parentfolderlist: {
      type: Array,
      default: () => [],
    },
    patid: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: true,
    },
    showLoader: {
      type: Boolean,
      default: false,
    },
    showSideButton: {
      type: Boolean,
      default: true,
    },
    boldfolder: {
      type: String,
      default: "",
    },
     restoreOnMount: {
    type: Boolean,
    default: true, // root restores; nested will override to false
  },
  },
  data() {
    return {
      patientid: "",
      restorePhase: this.restoreOnMount,
      listdata: [],
      ancestors: [],
      openfolder: "",
      loadedOnce: {},
      showFolderLoading: {},
      userpermissions: [],
      foldertreelist: {},
      hasChildList: {},
      showTreeLoader: {},
      folderswitch: {},
      firstclassname: this.patid,
      folderbyid: "",
      currentselectedfolder: "",
      selectedboldfolder: "",
      previousChild: "",
      showDetails: false,
      anyuserpermissions: false,
      showBlock: false,
      arrayfolders: [],
      openfolderlist: [],
      baseurl: process.env.VUE_APP_Service_URL,
      alreadyOpened: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    const previousRouteName = from.name;
    next((vm) => {
      vm.previousRouteName = previousRouteName;
    });
  },
  async beforeMount() {
    await this.setlist();
    this.arrayfolders = store.getters.getFolderDetails;
  },
  async mounted() {
    let previousroute = store.getters.getPrevRoute;
    console.log("previousroute",previousroute, previousroute == "documentview");
  this.openfolderlist = store.getters.getopenfolderlist || [];

  // If this instance isn't supposed to restore (phase is off), bail.
  if (!this.restorePhase) return;

  // If coming from folderDocLogin, open its ancestor chain first.
  if (this.previousRouteName === 'folderDocLogin') {
    this.openfolder = store.getters.getopenfolder || this.boldfolder || "";
    if (this.openfolder) {
      this.currentselectedfolder = this.openfolder;
      await this.getAncestors(this.openfolder);
    }
  }

  // Now restore ALL nodes that belong to THIS instance’s immediate list.
  // (Children will restore their own lists because they receive restoreOnMount=true.)
  await this.restoreOpenState();

  // 🔒 End the restore phase so any components mounted after user clicks won't auto-restore.
  this.restorePhase = false;
},
  watch: {
    "$store.getters.getFolderId": function (val) {
      this.currentselectedfolder = val;
    },

    "$store.getters.getFolder": async function (val) {
      if (store.getters.geteditfolderid != "") {
        this.currentselectedfolder = val;
        await this.getLastAncestor(store.getters.geteditfolderid);
      }
    },

    // "$store.getters.getFolder": async function (val) {
    //   if (store.getters.geteditfolderid != "") {
    //     this.currentselectedfolder = val;
    //     await this.getfolderslastancestor(store.getters.geteditfolderid);
    //   }
    // },
    boldfolder(newVal) {
      this.currentselectedfolder = newVal;
    },
  },
  methods: {
    resolveCount(elem) {
    const id = elem?.id;
    if (id && this.countsMap && this.countsMap[id] != null) {
      return this.countsMap[id];
    }
    // fallback to API-provided count if our map doesn’t have it
    return typeof elem.documentCount === 'number' ? elem.documentCount : 0;
  },
    async restoreOpenState() {
    // Only expand ids that are part of this level
    const idsAtThisLevel = new Set(this.list.map(x => x.id));
    // Keep order stable by walking the stored list
    for (const tag of this.openfolderlist) {
      const id = tag.replace(/^etmf-/, '');
      if (idsAtThisLevel.has(id)) {
        await this.getFolderChildren(id, { select: false, ensureOpen: true });
      }
    }
  },
    collapseDescendants(rootId) {
      // DFS through the cached tree to find expanded descendants
      const stack = (this.foldertreelist[rootId] || []).map(c => c.id);

      const toClose = [];
      while (stack.length) {
        const nodeId = stack.pop();

        // If this node is expanded, mark to close
        if (this.folderswitch[nodeId]) toClose.push(nodeId);

        // Traverse deeper only if we have children cached
        const kids = this.foldertreelist[nodeId];
        if (kids && kids.length) {
          for (const child of kids) stack.push(child.id);
        }
      }

      // Close all expanded descendants and purge from openfolderlist
      for (const id of toClose) {
        this.folderswitch = { ...this.folderswitch, [id]: false };

        const tag = `etmf-${id}`;
        const idx = this.openfolderlist.indexOf(tag);
        if (idx !== -1) this.openfolderlist.splice(idx, 1);
      }

      // Persist the cleaned list
      store.dispatch("setopenfolderlist", this.openfolderlist);
    },
    folderFunctionality(type, popupId, ancestors) {
      this.closePopover(popupId)
      const eventMap = {
        edit: 'editFolder',
        add: 'addFolder',
        delete: 'deleteFolder',
        archive: 'archiveFolder',
        clone: 'cloneFolder',
        export: 'exportFolder',
        permission: 'addFolderPermission',
        share: 'shareFolderPermission',
        upload: 'uploadDocument',
        emptyChild: "emptyChild",
        exportFolderTreeStructure: "exportFolderTreeStructure",
        folderType: "folderType"
      };

      const eventName = eventMap[type];
      if (eventName) {
        if (eventName != 'editFolder' && eventName != 'archiveFolder') {
          this.$emit(eventName, ancestors);
        }
        else {
          this.$emit(eventName);
        }

      }
    },
    handleInnerFunc(type, ancestors) {
      const eventMap = {
        edit: 'editFolder',
        add: 'addFolder',
        delete: 'deleteFolder',
        archive: 'archiveFolder',
        clone: 'cloneFolder',
        export: 'exportFolder',
        permission: 'addFolderPermission',
        share: 'shareFolderPermission',
        upload: 'uploadDocument',
        emptyChild: "emptyChild",
        exportFolderTreeStructure: "exportFolderTreeStructure",
        folderType: "folderType"
      };

      const eventName = eventMap[type];
      if (eventName) {
        if (eventName != 'editFolder' && eventName != 'archiveFolder') {
          this.$emit(eventName, ancestors);
        }
        else {
          this.$emit(eventName);
        }

      }
    },
    async closePopover(id) {
      document.getElementById(id) ? document.getElementById(id).hidePopover() : null
    },
    async setlist() {
      this.listdata = [...this.list];
    },
    async openSidePopup(elem) {
      this.showFolderLoading[elem.id] = true;
      try {
        store.dispatch('setFolderId', elem.id);
        this.getFolderUserpermission(elem.id);
        const idtoken = store.getters.getIdToken;
        const res = await axios.get(
          `${this.baseurl}/etmf/folder/getprivilegedchildren?Id=${elem.id}&StudyId=${store.getters.getStudyIs}`,
          { headers: { Authorization: "Bearer " + idtoken, "Content-Type": "application/json" } }
        );
        this.hasChildList[elem.id] = res.data;
        if (this.hasChildList[elem.id].length) {
          this.$emit("folderType", this.hasChildList[elem.id][0].type || '');
        } else {
          await this.checkType(elem.id);
        }
      } catch (err) {
        console.log(err.message);
      } finally {
        // In case permission call didn’t run/return yet
        this.showFolderLoading[elem.id] = false;
      }
    },
    async checkType(elem) {
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/etmf/folder/getnextfoldertype?parentId=${elem}&studyId=${store.getters.getStudyIs}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        if (res.data && res.data.inferredType) {
          this.$emit("folderType", res.data.inferredType)
        }
        else {
          this.$emit("folderType", "")
        }
      } catch (err) {
        console.log(err.message);
      }
    },
    async getInitialTree(id) {
      if (this.alreadyOpened.includes(id)) {
        console.debug(`Skipping ${id}, already opened`)
        return
      }
      else {
        this.alreadyOpened.push(id)
        this.getFolderChildren(id)
      }
    },
    async getFolderChildren(
      id,
      { select = true, ensureOpen = false, reload = false } = {}
    ) {
      const token = store.getters.getIdToken;
      const url = `${this.baseurl}/etmf/folder/getprivilegedchildren?Id=${id}&StudyId=${store.getters.getStudyIs}`;

      // ---------------- OPEN/CLOSE BEHAVIOR ----------------
      if (!ensureOpen && this.folderswitch[id]) {
        // COLLAPSE
        this.folderswitch = { ...this.folderswitch, [id]: false };

        // (optional) clear selection if collapsing the selected node
        if (select && this.currentselectedfolder === id) {
          store.dispatch("setFolderId", "");
          this.currentselectedfolder = "";
          this.$emit("folderType", "");
        }

        // Close all expanded descendants so they won't auto-open later
        if (typeof this.collapseDescendants === "function") {
          this.collapseDescendants(id);
        }

        // Remove this node from persisted open list
        const tag = `etmf-${id}`;
        const idx = this.openfolderlist.indexOf(tag);
        if (idx !== -1) this.openfolderlist.splice(idx, 1);
        await store.dispatch("setopenfolderlist", this.openfolderlist);

        // Ensure loader not stuck
        this.showTreeLoader = { ...this.showTreeLoader, [id]: false };
        return;
      }

      // Ensure it's open (no toggle when ensureOpen=true)
      if (!this.folderswitch[id]) {
        this.folderswitch = { ...this.folderswitch, [id]: true };
      }

      // ---------------- SELECTION & OPEN LIST ---------------
      if (select) {
        store.dispatch("setFolderId", id);
        this.currentselectedfolder = id;
      }
      const tag = `etmf-${id}`;
      if (!this.openfolderlist.includes(tag)) {
        this.openfolderlist.push(tag);
        await store.dispatch("setopenfolderlist", this.openfolderlist);
      }

      // ---------------- FETCH DECISION ----------------------
      const needFetch = reload || !this.loadedOnce[id];
      if (!needFetch) {
        // No fetch; still emit type if user changed selection
        if (select) {
          if (this.foldertreelist[id]?.length) {
            this.$emit("folderType", this.foldertreelist[id][0].type || "");
          } else {
            await this.checkType(id);
          }
        }
        return;
      }

      // ---------------- FETCH CHILDREN ----------------------
      this.showTreeLoader = { ...this.showTreeLoader, [id]: true };
      try {
        const res = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
        });

        this.foldertreelist = { ...this.foldertreelist, [id]: res.data };
        this.loadedOnce = { ...this.loadedOnce, [id]: true };

        if (select) {
          if (this.foldertreelist[id]?.length) {
            this.$emit("folderType", this.foldertreelist[id][0].type || "");
          } else {
            await this.checkType(id);
          }
        }
      } catch (err) {
        console.error("Error fetching folder children:", err);
      } finally {
        this.showTreeLoader = { ...this.showTreeLoader, [id]: false };
      }

      // Keep permissions panel accurate
      this.getFolderUserpermission(id);
    },
    async getFolderUserpermission(id) {
      this.userpermissions = [];
      const idtoken = store.getters.getIdToken;

      await axios
        .get(
          `${this.baseurl}/etmf/folderfilepermission/getuserfolderpermission?FolderId=${id}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then(async (res) => {
          this.userpermissions =
            res.data != null ? res.data : [];
          if (this.userpermissions.length == 0) {
            this.anyuserpermissions = false;
          } else {
            if (
              this.userpermissions.includes("Clone") ||
              this.userpermissions.includes("Permissions") ||
              this.userpermissions.includes("Share") ||
              this.userpermissions.includes("Edit") ||
              this.userpermissions.includes("Delete") ||
              this.userpermissions.includes("Archive") ||
              this.userpermissions.includes("Download")
            ) {
              this.anyuserpermissions = true;
            } else {
              this.anyuserpermissions = false;
            }
          }
          this.showFolderLoading[id] = false

        })
        .catch((err) => {
          this.showFolderLoading[id] = false
          console.log(err);
        });
    },
    async getAncestors(folderid) {
      if (!folderid) return;
      try {
        const idtoken = store.getters.getIdToken;
        const res = await axios.get(
          `${this.baseurl}/etmf/folder/getfolderbyid?Id=${folderid}&StudyId=${store.getters.getStudyIs}`,
          { headers: { Authorization: "Bearer " + idtoken, "Content-Type": "application/json" } }
        );
        this.ancestors = res.data.ancestorIds || [];
        await this.setFolderStruct(folderid);
      } catch (err) {
        console.log(err);
      }
    },
    async setFolderStruct(folderid) {
      for (const eachid of this.ancestors) {
        await this.getAncestorFolder(eachid);
      }
      await this.getAncestorFolder(folderid);
    },
    async getAncestorFolder(id) {
      if (!this.folderswitch[id]) {
        this.folderswitch = { ...this.folderswitch, [id]: true };
      }
      // Load once (no selection changes) and don’t toggle:
      await this.getFolderChildren(id, { select: false, ensureOpen: true });
    },
    async reloadallfolders() {
      for (const element of this.list) {
        if (this.folderswitch[element.id]) {
          await this.refreshfolder(element.id);
        }
      }
    },
    async refreshfolder(id) {
      if (!this.folderswitch[id]) return;
      await this.getFolderChildren(id, { select: false, ensureOpen: true, reload: true });
    },
    async getLastAncestor(id) {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseurl}/etmf/folder/getfolderbyid?Id=${id}&StudyId=${store.getters.getStudyIs}`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          let editedfolderdetails = [];
          editedfolderdetails = res.data.ancestorIds;
          let lastancestor =
            editedfolderdetails[editedfolderdetails.length - 1];
          document.getElementById(lastancestor + "doc").click();
          document.getElementById(lastancestor + "doc").click();
          document.getElementById(res.data.id + "doc").click();
          store.dispatch("seteditfolderid", "");
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};